import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { b2bServiceLevelConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `b2bServiceLevelConfig`. Page-specific JSX is
// the breadcrumb (headerBanner) and the supported-templates dropzone line.
// Controller renders "admin/b2b/ServiceLevelUploads".
export default function ServiceLevelUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={b2bServiceLevelConfig}
      headerBanner={
        <div className="mb-2 flex items-center gap-1.5 text-xs text-ink-muted">
          <span>Data</span>
          <span>/</span>
          <span>B2B Data</span>
          <span>/</span>
          <span className="text-ink-body font-medium">B2B - Service Level</span>
        </div>
      }
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          Template yang didukung: IDG (SLProdMon), IDM (REG / SC), Worksheet (SIL, MIDI, SAT), Sheet1 (SAT 2023)
        </p>
      }
      {...props}
    />
  )
}
